<template>
    <div class="wp-container" ref="root">
        <button type="button" class="wp-input" :class="{ 'is-open': open }" :disabled="disabled" @click="toggle">
            <span class="wp-text" :class="{ 'is-placeholder': !selectedWeek }">
                {{ displayText }}
            </span>

            <span class="wp-icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M16.2495 2.49979H14.3745V1.87479C14.3745 1.70903 14.3087 1.55005 14.1915 1.43284C14.0742 1.31563 13.9153 1.24979 13.7495 1.24979C13.5838 1.24979 13.4248 1.31563 13.3076 1.43284C13.1904 1.55005 13.1245 1.70903 13.1245 1.87479V2.49979H6.87451V1.87479C6.87451 1.70903 6.80866 1.55005 6.69145 1.43284C6.57424 1.31563 6.41527 1.24979 6.24951 1.24979C6.08375 1.24979 5.92478 1.31563 5.80757 1.43284C5.69036 1.55005 5.62451 1.70903 5.62451 1.87479V2.49979H3.74951C3.41809 2.50011 3.10034 2.63191 2.86599 2.86626C2.63164 3.10061 2.49984 3.41837 2.49951 3.74979V16.2498C2.49984 16.5812 2.63164 16.899 2.86599 17.1333C3.10034 17.3677 3.41809 17.4995 3.74951 17.4998H16.2495C16.5809 17.4995 16.8987 17.3677 17.133 17.1333C17.3674 16.899 17.4992 16.5812 17.4995 16.2498V3.74979C17.4992 3.41837 17.3674 3.10061 17.133 2.86626C16.8987 2.63191 16.5809 2.50011 16.2495 2.49979ZM16.2495 6.24979H3.74951V3.74979H5.62451V4.37479C5.62451 4.54055 5.69036 4.69952 5.80757 4.81673C5.92478 4.93394 6.08375 4.99979 6.24951 4.99979C6.41527 4.99979 6.57424 4.93394 6.69145 4.81673C6.80866 4.69952 6.87451 4.54055 6.87451 4.37479V3.74979H13.1245V4.37479C13.1245 4.54055 13.1904 4.69952 13.3076 4.81673C13.4248 4.93394 13.5838 4.99979 13.7495 4.99979C13.9153 4.99979 14.0742 4.93394 14.1915 4.81673C14.3087 4.69952 14.3745 4.54055 14.3745 4.37479V3.74979H16.2495V6.24979Z"
                        fill="#C4C4C4" />
                </svg>
            </span>
        </button>

        <div v-if="open" class="wp-dropdown">
            <div v-if="weeks.length === 0" class="wp-empty">
                {{ $t('empty_data') }}
            </div>

            <button v-for="w in weeks" :key="w.key" type="button" class="wp-item" :class="{ 'is-active': isActive(w) }" @click="selectWeek(w)">
                {{ w.label }}
            </button>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    name: "WeekPicker",
    props: {
        startDate: { type: [String, Number, Date, Object], required: true },
        endDate: { type: [String, Number, Date, Object], required: true },
        value: { type: Object, default: null },
        placeholder: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        alignToMonday: { type: Boolean, default: false },
        includePartialLastWeek: { type: Boolean, default: true },
        dayFormat: { type: String, default: "DD MMM" },
    },

    data() {
        return {
            open: false,
            innerValue: null
        };
    },

    computed: {
        selectedWeek() {
            return this.value || this.innerValue;
        },

        displayText() {
            if (this.selectedWeek && this.selectedWeek.label) return this.selectedWeek.label;

            // placeholder mặc định theo ví dụ nếu không truyền
            return this.placeholder || this.$i18n.t('choose_week');
        },

        weekText() {
            return "Week";
        },

        // weeks() {
        //     const locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : "en";
        //     moment.locale(locale);

        //     const start = this.toMomentStartOfDay(this.startDate);
        //     const end = this.toMomentStartOfDay(this.endDate);

        //     if (!start.isValid() || !end.isValid() || start.isAfter(end)) return [];

        //     let cursor = start.clone();

        //     if (this.alignToMonday) {
        //         cursor = cursor.clone().isoWeekday(1);
        //         if (cursor.isAfter(start)) cursor.subtract(7, "days");
        //     }

        //     const weeks = [];
        //     let index = 1;

        //     while (cursor.isSameOrBefore(end, "day")) {
        //         const ws = cursor.clone();
        //         let we = cursor.clone().add(6, "days");

        //         if (this.includePartialLastWeek && we.isAfter(end)) {
        //             we = end.clone();
        //         }

        //         if (!this.includePartialLastWeek && we.isAfter(end)) {
        //             break;
        //         }

        //         const label = `${this.$i18n.t('week')} ${String(index).padStart(2, "0")}, ${ws.format(this.dayFormat)} - ${we.format(this.dayFormat)}`;

        //         weeks.push({
        //             key: `${index}-${ws.format("YYYY-MM-DD")}`,
        //             weekIndex: index,
        //             start: ws,
        //             end: we,
        //             label
        //         });

        //         index += 1;
        //         cursor = cursor.add(7, "days");
        //     }
        //     return weeks;
        // }

        weeks() {
            const locale = (this.$i18n && this.$i18n.locale) ? this.$i18n.locale : "en";
            const start = this.toMomentStartOfDay(this.startDate).locale(locale);
            const end = this.toMomentStartOfDay(this.endDate).locale(locale);

            if (!start.isValid() || !end.isValid() || start.isAfter(end)) return [];

            // 1) Căn ngày bắt đầu tuần = THỨ 2 gần nhất <= start
            let cursor = start.clone().isoWeekday(1);
            if (cursor.isAfter(start)) cursor.subtract(7, "days");

            const weeks = [];
            let index = 1;

            while (cursor.isSameOrBefore(end, "day")) {
                const blockStart = cursor.clone();            // Monday
                const blockEnd = cursor.clone().add(6, "d"); // Sunday

                // 2) Lấy phần giao
                const ws = moment.max(blockStart, start);
                const we = moment.min(blockEnd, end);

                if (ws.isSameOrBefore(we, "day")) {
                    const label =
                        `${this.$i18n.t('week')} ${String(index).padStart(2, "0")}, ` +
                        `${ws.format(this.dayFormat)} - ${we.format(this.dayFormat)}`;

                    weeks.push({
                        key: `${index}-${ws.format("YYYY-MM-DD")}`,
                        weekIndex: index,
                        start: ws,
                        end: we,
                        label
                    });

                    index++;
                }

                cursor.add(7, "days"); // sang tuần tiếp theo
            }

            return weeks;
        }
    },

    watch: {
        open(val) {
            if (val) this.bindOutside();
            else this.unbindOutside();
        },

        weeks: {
            immediate: true,
            handler(newWeeks) {
                if (!newWeeks || newWeeks.length === 0) return;
                if (this.value) return;
                if (this.innerValue) return;

                const preferred = this.findWeekForToday(newWeeks);
                this.selectWeek(preferred || newWeeks[0]);
            }
        }
    },

    beforeDestroy() {
        this.unbindOutside();
    },

    methods: {

        toMoment(input, { keepOffset = true } = {}) {
            if (input == null || input === "") return moment.invalid();

            if (moment.isMoment(input)) return input.clone();

            if (input instanceof Date) return moment(input);

            if (typeof input === "number") {
                const ms = input < 1e12 ? input * 1000 : input; // heuristic
                return moment(ms);
            }

            if (typeof input === "string") {
                const s = input.trim();

                if (/^\d+$/.test(s)) {
                    const num = Number(s);
                    const ms = num < 1e12 ? num * 1000 : num;
                    return moment(ms);
                }

                const iso = keepOffset
                    ? moment.parseZone(s, moment.ISO_8601, true)
                    : moment(s, moment.ISO_8601, true);

                if (iso.isValid()) return iso;

                const loose = moment(s);
                return loose.isValid() ? loose : moment.invalid();
            }

            if (typeof input === "object") {
                if (input.date) return this.toMoment(input.date, { keepOffset });

                const m = moment(input);
                return m.isValid() ? m : moment.invalid();
            }

            return moment.invalid();
        },

        toMomentStartOfDay(input) {
            const m = this.toMoment(input, { keepOffset: true });
            return m.isValid() ? m.clone().startOf("day") : moment.invalid();
        },

        toggle() {
            if (this.disabled) return;
            this.open = !this.open;
        },

        close() {
            this.open = false;
        },


        findWeekForToday(weeks) {
            const today = moment().startOf('day');
            const current = weeks.find(w => today.isSameOrAfter(w.start, 'day') && today.isSameOrBefore(w.end, 'day'));
            if (current) return current;

            const end = this.toMomentStartOfDay(this.endDate);
            if (end.isValid() && today.isAfter(end, 'day')) {
                return weeks[weeks.length - 1];
            }

            return null;
        },


        selectWeek(w) {
            this.innerValue = w;
            this.$emit("input", w);
            this.$emit("change", w);
            this.close();
        },

        isActive(w) {
            const s = this.selectedWeek;
            if (!s) return false;
            return s.weekIndex === w.weekIndex && s.start && moment(s.start).isSame(w.start, "day");
        },

        bindOutside() {
            document.addEventListener("mousedown", this.handleClickOutside);
            document.addEventListener("touchstart", this.handleClickOutside);
        },

        unbindOutside() {
            document.removeEventListener("mousedown", this.handleClickOutside);
            document.removeEventListener("touchstart", this.handleClickOutside);
        },

        handleClickOutside(e) {
            const root = this.$refs.root;
            if (!root) return;
            if (root.contains(e.target)) return;
            this.close();
        }
    }
};
</script>

<style scoped>
.wp-container {
    position: relative;
    width: 280px;
    font-family: system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif;
}

.wp-input {
    width: 100%;
    height: 36px;
    padding: 0 12px;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: pointer;
}

.wp-input:hover {
    border-color: #d1d5db;
}

.wp-input.is-open {
    border-color: #cbd5e1;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.wp-input:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.wp-text {
    color: #111827;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.wp-text.is-placeholder {
    color: #9ca3af;
}

.wp-icon {
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
}

.wp-dropdown {
    position: absolute;
    z-index: 50;
    top: calc(100% + 6px);
    left: 0;
    width: 100%;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    padding: 6px;
    max-height: 280px;
    overflow: auto;
}

.wp-item {
    width: 100%;
    padding: 10px 10px;
    border: none;
    background: transparent;
    text-align: left;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    color: #111827;
}

.wp-item:hover {
    background: #f3f4f6;
}

.wp-item.is-active {
    background: #e5f0ff;
    color: #1d4ed8;
}

.wp-empty {
    padding: 10px;
    color: #6b7280;
    font-size: 14px;
}
</style>